import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { email, phone } from 'constants/contact'
import EmailIcon from 'images/icons/icon-email-alpha.svg'
import PhoneIcon from 'images/icons/icon-phone-alpha.svg'
import React, { FC } from 'react'
import { scopedTranslation } from 'src/helpers'

import { useStyles } from './DesktopContact.styles'

const { t } = scopedTranslation('application.footer')

export const DesktopContact: FC = () => {
  const classes = useStyles()

  return (
    <Grid container={ true } direction='row' item={ true } xs={ 12 } wrap='wrap'>
      <Grid container={ true } item={ true } xs={ 12 }>
        <Typography className={ classes.text } component='p' variant='h4'>{ t('any_questions') }</Typography>
      </Grid>
      <Grid container={ true } item={ true } xs={ 5 }>
        <Link className={ classes.link } data-track-context='Footer' data-track-element='User_Telefon' href={ `tel:${phone}` }>
          <img className={ classes.icon } src={ PhoneIcon } alt='Tel:' />
          <Box component='span' display='flex' flexDirection='column'>
            <Typography className={ classes.linkText } color='inherit' component='span' variant='h4'>{ phone }</Typography>
            <Typography className={ classes.linkText } color='inherit' component='span' variant='h4'>{t('calling_times')}</Typography>
          </Box>
        </Link>
      </Grid>
      <Grid container={ true } item={ true } xs={ 5 }>
        <Link className={ classes.link } href={ `mailto:${email}` }>
          <img className={ classes.icon } src={ EmailIcon } alt='Email:' />
          <Typography className={ classes.linkText } color='inherit' component='span' variant='h4'>{ email }</Typography>
        </Link>
      </Grid>
    </Grid>
  )
}
